import { DelegateProvider } from './delegate-provider.interface';
import { INotificationDisplayDetails } from 'app-core/src/models/notification-display-details.model';
import { Application } from '../models/application.model';
import { Game } from '../models/game.model';

export const kNameOfNotificationWindowManagerService =
  'NotificationWindowManagerService';

// -----------------------------------------------------------------------------
export interface INotificationWindowManagerServiceDelegate {
  onNotificationWindowClosed?(
    info: INotificationDisplayDetails,
    visibileTimeInMs: number,
  );
  onNotificationDismissed?(info: INotificationDisplayDetails);
  onNotificationReachedMinTimeToDisplay?(info: INotificationDisplayDetails);
}

// -----------------------------------------------------------------------------
// This is the background interface for NotificationWindowServiceImpl - which
// communicates with the notification window
export interface INotificationWindowManagerService
  extends DelegateProvider<INotificationWindowManagerServiceDelegate> {
  show(
    game: Game,
    application: Application,
    isTester?: boolean,
    useDevEnv?: string,
  );
  close(force?: boolean);
  isNotificationShown(): Promise<boolean>;
  getNotificationInfo(): INotificationDisplayDetails;
}
